import { Users, Check, UserCog, Shield, Eye, User } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ROLES = [
  { icon: UserCog, label: "Owner" },
  { icon: Shield, label: "Admin" },
  { icon: User, label: "Member" },
  { icon: Eye, label: "Viewer (read-only)" },
];

const POINTS = [
  "Four clear roles — Owner, Admin, Member and Viewer (read-only)",
  "Seats in every plan — 1 on Free, 5 on Growth, 20 on Scale",
  "Add extra seats on any paid plan for £7/seat/month (excl. VAT), billed pro-rata",
  "Pending invites hold a seat until accepted",
];

export const TeamSection = () => {
  return (
    <section
      id="features"
      data-testid="team-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <div className="flex items-center gap-2">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-brand-blue/10 text-brand-blue">
                  <Users className="h-5 w-5" strokeWidth={2} />
                </span>
                <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-blue">
                  Team access
                </p>
              </div>
              <h2 className="mt-5 font-heading font-700 text-3xl sm:text-4xl tracking-tight text-brand-navy">
                Bring your whole team
              </h2>
              <p className="mt-5 text-lg leading-relaxed text-slate-600">
                Blue Shuck isn't just for one person. Invite your estimators,
                site team and admins — and give clients or accountants read-only
                access when you need a second pair of eyes.
              </p>

              <div className="mt-7 flex flex-wrap gap-2">
                {ROLES.map((r) => {
                  const Icon = r.icon;
                  return (
                    <span
                      key={r.label}
                      data-testid={`team-role-${r.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3.5 py-1.5 text-xs font-medium text-slate-700"
                    >
                      <Icon className="h-3.5 w-3.5 text-brand-blue" />
                      {r.label}
                    </span>
                  );
                })}
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <ul className="space-y-4">
                {POINTS.map((p, i) => (
                  <li
                    key={i}
                    data-testid={`team-point-${i}`}
                    className="flex items-start gap-3 rounded-xl border border-slate-200 bg-slate-50 p-5"
                  >
                    <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-brand-blue/10 text-brand-blue">
                      <Check className="h-4 w-4" strokeWidth={2.5} />
                    </span>
                    <span className="text-sm leading-relaxed text-slate-700">
                      {p}
                    </span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
